module.exports = __webpack_public_path__ + "static/media/HPHeader.f38c1ae4.png";